import RoutesIndex from './app/routes';
import { useInitData } from './views/auth/features/useInitData';

function App() {
  useInitData();

  return <RoutesIndex />;
}

export default App;
